import React, { useEffect } from 'react'
import { useAppContext } from '../../../app/AppContext'
import { useNavigate } from "react-router-dom";
import LoginPage from './components/LoginPage';
import ForgotPasswordPage from './components/ForgotPasswordPage'

export default function RoutesMenusLogin() {

    const navigate = useNavigate();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();
    useEffect(() => {
        addMenu({ uid: "loginPage", text: "Área Administrativa", iconName: "Input", action: () => { navigate("/login") }, })
        addRoute({ uid: "loginPage", title: "Área Administrativa", route: "/login", element: <LoginPage /> })
        addRoute({ uid: "forgotPasswordPage", title: "Forgot Password", route: "/forgot-password", element: <ForgotPasswordPage /> })
        return () => { removeMenusRoutes('loginPage') }
    }, [addMenu, addRoute, navigate, removeMenusRoutes])

    return (<></>)
}
